import { render, staticRenderFns } from "./SSelectorChips.vue?vue&type=template&id=532f9296&scoped=true"
import script from "./SSelectorChips.vue?vue&type=script&lang=ts"
export * from "./SSelectorChips.vue?vue&type=script&lang=ts"
import style0 from "./SSelectorChips.vue?vue&type=style&index=0&id=532f9296&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532f9296",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('532f9296')) {
      api.createRecord('532f9296', component.options)
    } else {
      api.reload('532f9296', component.options)
    }
    module.hot.accept("./SSelectorChips.vue?vue&type=template&id=532f9296&scoped=true", function () {
      api.rerender('532f9296', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/components/stemdo-components/s-selector-multiple/SSelectorChips.vue"
export default component.exports